//styles/loadingStyles.js
export const spinnerContainer = (theme) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "80vh",
  gap: theme.spacing(2),
});

export const spinnerCircle = (theme) => ({
  color: theme.palette.primary.main,
});
